import { css } from '@emotion/react';
import styled from '@emotion/styled';
import type { FC } from 'react';

export interface ReviewStarsProps {
  amount: number;
}

export const ReviewStars: FC<ReviewStarsProps> = (props) => {
  const { amount, ...rest } = props;

  return (
    <StarIcons {...rest}>
      <StarRatingsYellow
        css={css`
          width: ${amount * 20}%;
        `}
      >
        {[1, 2, 3, 4, 5].map((number, index) => {
          return <span key={index}>★</span>;
        })}
      </StarRatingsYellow>
      <StarRatingsGrey>
        {[1, 2, 3, 4, 5].map((number, index) => {
          return <span key={index}>★</span>;
        })}
      </StarRatingsGrey>
    </StarIcons>
  );
};

const StarIcons = styled.div`
  unicode-bidi: bidi-override;
  position: relative;
  font-size: 16px;
  height: 20px;
  padding: 0;
`;

const StarRatingsGrey = styled.div`
  color: #c3c5ca;
  display: block;
  z-index: 0;
`;

const StarRatingsYellow = styled.div`
  color: #ffd05b;
  position: absolute;
  z-index: 1;
  display: block;
  top: 0;
  left: 0;
  overflow: hidden;
  height: inherit;
  white-space: nowrap;
`;
